// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3kcmZ","footer":"ChangeClinic_footer__2ZrQS"};